/**
 * No-op analytics adapter. Does nothing. Used in tests and as a fallback
 * when no analytics provider is configured.
 *
 * Conforms to AnalyticsAdapter (see src/analytics/contract.js).
 */

const noopAdapter = {
  name: "noop",
  init: async () => {},
  identify: () => {},
  alias: () => {},
  track: () => {},
  page: () => {},
  captureError: () => {},
  reset: () => {},
  setOptOut: () => {},
};

export default noopAdapter;
